export default __webpack_public_path__ + "static/media/page1Image2.69836573.jpg";